<div class="photo-wrapper">
  <div class="svg-wrapper" *ngIf="!photo">
    <lv-camera-feed class="mirror" filename="face.png" (capture)="capture($event)"></lv-camera-feed>
    <img class="svg-item" src="assets/photo-oval.svg" />
  </div>
  <img id="the-photo" *ngIf="photo" [src]="photoURL" />
  <div *ngIf="saving" class="photo-uploading" translate>app.uploading</div>
</div>
